export default [18.483402, -69.929611];